// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"page-container_pageContainer__8yuzg"};